import { useMessageStore } from "@/state/stores";
import { useShallow } from "zustand/react/shallow";

/**
 * Hook that checks if any data is currently being processed
 * @returns true if any messages, files, or message parts are being processed
 */
export function useIsProcessing() {
  const isMessageProcessing = useMessageStore(
    useShallow((state) => {
      return state.messages.some((message) => {
        // Check message status
        if (message.status === "pending" || message.status === "processing") {
          return true;
        }

        // Check message parts if they exist
        if (message.parts) {
          return message.parts.some((part) => {
            if (part.type === "text" && part.status === "streaming") {
              return true;
            }
            if (
              part.type === "tool-call" &&
              (part.status === "pending" || part.status === "executing")
            ) {
              return true;
            }
            return false;
          });
        }

        return false;
      });
    }),
  );

  const isFileProcessing = useMessageStore(
    useShallow((state) => {
      // Check all version information for processing files/specs
      return Object.values(state.versionInformation).some((versionInfo) => {
        // Check files in version
        const hasProcessingFiles = versionInfo.files.some(
          (file) => file.status === "processing",
        );

        // Check spec in version
        const hasProcessingSpec = versionInfo.spec?.status === "processing";

        return hasProcessingFiles || hasProcessingSpec;
      });
    }),
  );

  return isMessageProcessing || isFileProcessing;
}
